import { Button, Col, Form, Row } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageName from "./PageName";
import toast from "react-hot-toast";
import { getUuid } from "../../../../helpers/functions";
import {
  AppDispatch,
  createSystemRole,
  createSystemRoleClear,
  createSystemRoleRequest,
  getSystemRoleListRequest,
  getSystemUiModuleListRequest,
  SystemRole,
  updateSystemRole,
  updateSystemRoleClear,
  updateSystemRoleRequest,
} from "../../../../redux";
import HomeUiModule from "./HomeUiModal";
import { useTranslation } from "react-i18next";

interface RoleFormProps {
  close: () => void;
  actionType: string;
  getId?: string;
  actionItem?: SystemRole;
  setLoading: (loading: boolean) => void;
  setExpandedRowKey: (key: string | null) => void;
  linkType?: string;
}

const RoleForm: React.FC<RoleFormProps> = (props) => {
  const {
    close,
    actionType,
    getId,
    actionItem,
    setLoading,
    setExpandedRowKey,
    linkType,
  } = props;

  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const {
    result: createStatus,
    loading: createLoading,
    error: createError,
  } = useSelector(createSystemRole);

  const {
    result: updateStatus,
    loading: updateLoading,
    error: updateError,
  } = useSelector(updateSystemRole);

  useEffect(() => {
    if (createStatus?.status === "success") {
      toast.success("Role created successfully");
      systemUiModuleList();
      close();
      dispatch(createSystemRoleClear());
    } else if (createError?.message) {
      toast.error(createError.message);
      systemUiModuleList();
      dispatch(createSystemRoleClear());
    } else if (updateStatus?.status === "success") {
      toast.success("Role updated successfully");
      systemUiModuleList();
      close();
      dispatch(updateSystemRoleClear());
    } else if (updateError?.message === "error") {
      toast.error(updateError.message);
      systemUiModuleList();
      dispatch(updateSystemRoleClear());
    }
  }, [
    createStatus,
    createError,
    updateStatus,
    updateError,
    close,
    dispatch,
    setExpandedRowKey,
    setLoading,
  ]);

  const systemUiModuleList = () => {
    dispatch(
      getSystemUiModuleListRequest({
        sort: [{ field: "name", order: "asc" }],
      })
    );
    dispatch(
      getSystemRoleListRequest({
        sort: [{ field: "name", order: "asc" }],
      })
    );
  };

  const createRole = (data: any) => {
    let variable = { data };
    dispatch(createSystemRoleRequest(variable));
  };

  const updateRole = (data: any) => {
    let variable = { data, id: getId || "" };
    dispatch(updateSystemRoleRequest(variable));
  };

  const onFinish = (values: any) => {
    let uuid = getUuid();
    if (actionType === "add_role") {
      createRole({ ...values, id: uuid });
    } else {
      updateRole({
        ...values,
        id: getId,
      });
    }
  };

  useEffect(() => {
    if (actionType === "add_page") {
      form?.resetFields();
      form.setFieldsValue({});
    } else {
      form.setFieldsValue({ ...actionItem });
    }
  }, [actionItem, actionType, form]);

  return (
    <div>
      <Form name="create page" onFinish={onFinish} id="role_form" form={form}>
        <PageName />
        <HomeUiModule />
        <Row justify={"end"} gutter={10}>
          <Col>
            <Button onClick={close} danger>
              {t("close")}
            </Button>
          </Col>
          <Col>
            <Button
              key="confirm"
              type="primary"
              htmlType="submit"
              loading={createLoading || updateLoading}
            >
              {actionType === "add_role" ? t("create") : t("update")}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default RoleForm;
